import React from 'react'
import NumberCounter from './numbercount'
const Legitimacy = () => {
    return (
        <div>
            <div className="row px-2 py-5" style={{backgroundColor:"#121212"}}>
                <div className="col-md-3 col-12 text-center rounded-3 my-2" >
                    <div >
                        {/* <p className='h1 display-1 py-5'><i style={{ color: '#6565ff' }} class="fas fa-handshake fa-2xl"></i></p> */}
                        <h2 className='h4' style={{ color: "white" }} >Trusted By</h2>
                        <div className="d-flex justify-content-center">
                            <p className='h1 display-5 d-flex' style={{ fontWeight: '800', color: '#fff' }}>
                                <NumberCounter count={10000} />+
                            </p>
                            {/* <p className='h1 display-5' style={{ fontWeight: '900', color: '#fff' }}><i class="fas fa-plus"></i></p> */}

                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-12 text-center rounded-3 my-2" >
                    <div >
                        {/* <p className='h1 display-1 py-5'><i style={{ color: '#6565ff' }} class="fas fa-handshake fa-2xl"></i></p> */}
                        <h2 className='h4' style={{ color: "white" }} >Globally</h2>
                        <div className="d-flex justify-content-center">
                            <p className='h1 display-5' style={{ fontWeight: '800', color: '#fff' }}>
                                Audited
                            </p>
                            {/* <p className='h1 display-5' style={{ fontWeight: '900', color: '#fff' }}><i class="fas fa-plus"></i></p> */}

                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-12 text-center rounded-3 my-2" >
                    <div >
                        {/* <p className='h1 display-1 py-5'><i style={{ color: '#6565ff' }} class="fas fa-handshake fa-2xl"></i></p> */}
                        <h2 className='h4' style={{ color: "white" }} >Top Reviews</h2>
                        <div className="d-flex justify-content-center">
                            <p className='h1 display-6' style={{ fontWeight: '800', color: '#fff' }}>
                                <i className='fa fa-star rating-color'></i>
                                <i className='fa fa-star rating-color'></i>
                                <i className='fa fa-star rating-color'></i>
                                <i className='fa fa-star rating-color'></i>
                                <i className='fa fa-star rating-color'></i>
                            </p>
                            {/* <p className='h1 display-5' style={{ fontWeight: '900', color: '#fff' }}><i class="fas fa-plus"></i></p> */}

                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-12 text-center rounded-3 my-2" >
                    <div >
                        {/* <p className='h1 display-1 py-5'><i style={{ color: '#6565ff' }} class="fas fa-handshake fa-2xl"></i></p> */}
                        <h2 className='h4' style={{ color: "white" }} >Founded In</h2>
                        <div className="d-flex justify-content-center">
                            <p className='h1 display-5' style={{ fontWeight: '800', color: '#fff' }}>
                                <NumberCounter count={2025} />
                            </p>
                            {/* <p className='h1 display-5' style={{ fontWeight: '900', color: '#fff' }}><i class="fas fa-plus"></i></p> */}

                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default Legitimacy